module.exports = __webpack_public_path__ + "static/media/Sub 16.06eae63b.JPG";